
<div class="card mb-5" [attr.style]="(data?.colStyle || '') + (data?.rowStyle || '')" [style.margin-left]="data.marginleft" *ngIf="data">
  <div class="card-header" style="border-bottom: none;">
    <div class="card-title d-flex flex-column">
      <h4 [style.text-align]="data.titleAlignment || 'center'">{{ data.title | capitalCase }}</h4>
    </div>
  </div>
  <div class="card-body" style="padding: 10px 12px 10px; position: relative;">
    <!-- Chart container: direct child div[id] so global responsive CSS + service font scaling apply -->
    <div #chartContainer [id]="data.widgetId" style="width: 100%;" [style.height]="data?.height || 'var(--dvm-chart-height, 300px)'"></div>

    <!-- Horizontal scrollbar track -->
    <div class="scrollbar-track horizontal" *ngIf="allCategories.length > maxVisibleCategories">
      <div class="scrollbar-thumb horizontal"
           [style.width.px]="getScrollbarThumbWidth()"
           [style.left.px]="getScrollbarThumbLeft()"
           (mousedown)="onScrollbarMouseDown($event)">
      </div>
    </div>
  </div>
</div>
